//描述：搜索结果列表
//时间：2017-5-25
//作者：bai.zhiming
"use strict";
angular.module("headlinesHotListPageModule", []).controller("headlinesHotListPageCtrl", ["$scope", "$q", "$filter", "itemInfo", "trsHttpService", "$timeout", "$modalInstance",
    function($scope, $q, $filter, itemInfo, trsHttpService, $timeout, $modalInstance) {
        initStatus();
        initData();
        /*
         [initStatus 初始化状态]
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0
            };
            $scope.data = {
                id: itemInfo.id,
                "jumpToPageNum": 1,
            };
            $scope.status = {
                /*"今日头条热点",*/
                keywords: "",
                timeType: {
                    name: "全部时间",
                    value: ""
                },
                timeTypeJsons: [{
                    name: "全部时间",
                    value: ""
                }, {
                    name: "今天",
                    value: "0y"
                }, {
                    name: "最近三天",
                    value: "3d"
                }, {
                    name: "最近一周",
                    value: "1w"
                }, {
                    name: "最近二周",
                    value: "2w"
                }, {
                    name: "最近一月",
                    value: "1m"
                }, {
                    name: "最近一年",
                    value: "1y"
                }],

            };

        }
        /*
         [initData 初始化数据]
         */
        function initData() {
            getAPublicOpinion();
        }
        /*
         [getAPublicOpinion 数据请求]
         */
        function getAPublicOpinion() {
            /*
             [params 请求参数]
             */
            var params = {
                // "serviceid": "publicsentiment",
                // "modelid": "getnewlist",
                // "typeid": "widget",
                "serviceid": "pubSentimentMgr",
                "modelid": "getnewlist",
                "typeid": "screen",
                "id": $scope.data.id,
                "startpage": $scope.page.CURRPAGE - 1,
                "pagesize": $scope.page.PAGESIZE, //"10",
                "search_date": $scope.status.timeType.value,
                "search_word": $scope.status.keywords,
            };
            /*单独处理 自定义时间时传参*/
            if ($scope.status.timeType.value == "custom") {
                var startTime = timeStamp($scope.status.timeType.startdate);
                var endTime = timeStamp($scope.status.timeType.enddate);
                params.search_date = startTime + ";" + endTime;
            }
            /**
             * [timeStamp description]时间格式化
             * @param  {[type]} time [description]
             * @return {[type]}      [description]
             */
            function timeStamp(time) {
                var date = new Date(Date.parse(time));
                return $filter("date")(date, "yyyy-MM-dd").toString();
            }
            /*
            [loadingPromise 请求数据效果 ]
            */
             getData();
            /*
             [getData 请求数据 ]
             */
            function getData() {
                var deffer = $q.defer();
                $scope.loadingPromise=trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
                    setData(data);
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /*
             [setData 设置数据]
            */
            function setData(data) {
                $scope.data.publicSentiment = data.ITEMS.PAGEITEMS;
                //分页
                $scope.page.ITEMCOUNT = data.ITEMS.TOTALITEMCOUNT;
                $scope.page.PAGECOUNT = data.ITEMS.PAGETOTAL;
            }
        }

        /**
         *关闭弹窗的方法
         * 
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };
        /**
         * [pageChanged description]分页请求
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.data.jumpToPageNum = $scope.page.CURRPAGE;
            getAPublicOpinion();
        };
        $scope.jumpToPage = function() {
            if ($scope.data.jumpToPageNum > $scope.page.PAGECOUNT) {
                $scope.data.jumpToPageNum = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.data.jumpToPageNum;
            getAPublicOpinion();
        };
        /*
          [getselectTime 选择时间]
          */
        $scope.getselectTime = function() {
            getAPublicOpinion();
        };
        /*
         [queryListBySearchWord 检索]
         */
        $scope.queryListBySearchWord = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                getAPublicOpinion();
            }
        };
    }
]);